import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InappKeyboardService, InappKeyboardState } from '../../services/inapp-keyboard/inapp-keyboard.service';

@Component({
  selector: 'app-inapp-keyboard',
  templateUrl: './inapp-keyboard.component.html',
  styleUrls: ['./inapp-keyboard.component.scss']
})
export class InappKeyboardComponent implements OnInit, OnDestroy {
  state!: InappKeyboardState;
  sub?: Subscription;

  constructor(public keyboard: InappKeyboardService) {}

  ngOnInit(): void {
    this.sub = this.keyboard.state$.subscribe(st => this.state = st);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get isVisible() { return this.state?.visible; }
  get canConfirm(): boolean { return this.state?.valid ?? true; }

  press(ch: string) {
    this.keyboard.typeChar(ch);
  }

  backspace() {
    this.keyboard.backspace();
  }

  clear() {
    this.keyboard.clear();
  }

  confirm() {
    this.keyboard.confirm();
  }

  close() {
    this.keyboard.close(true);
  }

  toggleShift() {
    this.keyboard.toggleCaps();
  }

  toggleSymbols() {
    this.keyboard.toggleSymbols();
  }

  shownCharsRow1(): string[] {
    const r1 = this.state.symbols ? ['1','2','3','4','5','6','7','8','9','0'] : ['q','w','e','r','t','y','u','i','o','p'];
    return this.applyCaps(r1);
  }

  shownCharsRow2(): string[] {
    const r2 = this.state.symbols ? ['-','/',';',':','(',')','€','&','@','#'] : ['a','s','d','f','g','h','j','k','l','ñ'];
    return this.applyCaps(r2);
  }

  shownCharsRow3(): string[] {
    const r3 = this.state.symbols ? ['_', '"', '\'', '.', ',', '?', '!', '+', '='] : ['z','x','c','v','b','n','m'];
    return this.applyCaps(r3);
  }

  private applyCaps(chars: string[]): string[] {
    if (!this.state?.caps) return chars;
    return chars.map(c => c.length === 1 ? c.toUpperCase() : c);
  }
}

